import React, { Component, createRef } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import {
  Divider,
  TextField,
  Button,
  LinearProgress,
  Grid,
} from "@material-ui/core";
import Axios from "axios";

import { url } from "../../../../config/config";
import NavBar from "../../../../Component/NavBar/AdminHeader/AdminHeader";
import { useStyles } from "./AddBook.css";
import AdminPageTitle from "../../../../Component/AdminPageTitle/AdminPageTitle";
import FormLoader from "../../../../Component/FormLoader/FormLoader";

const CustomLinearProgress = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: "#1a90ff",
  },
}))(LinearProgress);

class AddBook extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countRef: createRef(),
      priceRef: createRef(),
      data: {
        title: "",
        author: "",
        genre: "",
        price: 0,
        pageCount: 0,
        publishedDate: "",
        profileUrl: "",
        description: "",
        pdfFile: "",
      },
      authorList: [],
      categoryList: [],
      titleError: "",
      pageCountError: "",
      priceError: "",
      descriptionError: "",
      bookCoverError: "",
      pdfFileUrl: "",
      imagePercentage: 0,
      filePercentage: 0,
      success: "",
      loading: false,
    };
  }

  async componentDidMount() {
    if (this.props.editStatus) {
      this.getBookData(this.props.bookId);
    }
    const response1 = await Axios.get(`${url}/api/authors`);
    const response2 = await Axios.get(`${url}/api/categories`);
    this.setState({
      authorList: response1.data,
      categoryList: response2.data,
    });
  }

  getBookData = async (bookId) => {
    const authorResponse = await Axios.get(`${url}/api/authors`);
    this.setState({
      authorList: authorResponse.data,
    });
    const response2 = await Axios.get(
      `${url}/api/books/${this.props.match.params.bookId}`
    );
    if (response2.data.length !== 0) {
      this.setState({
        data: {
          ...this.state.data,
          title: response2.data.title,
          genre: response2.data.genre,
          price: response2.data.price,
          author: response2.data.author._id,
          pageCount: response2.data.pageCount,
          description: response2.data.description,
          profileUrl: response2.data.bookCoverUrl,
          publishedDate: response2.data.publishedDate,
          pdfFile: response2.data.bookFileUrl,
        },
      });
      if (response2.data.bookFileUrl) {
        const pdfResponse = await Axios.get(
          `${url}/api/file/image/${response2.data.bookFileUrl}`,
          {
            headers: {
              "x-auth-token": this.props.adminToken,
            },
          }
        );
        if (pdfResponse.data) {
          this.setState({
            data: {
              ...this.state.data,
              pdfFileUrl: pdfResponse.data,
            },
          });
        }
      }
    }
  };

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleImageUpload = (e) => {
    let reader = new FileReader();
    let files = e.target.files[0];
    reader.onload = (e) => {
      this.setState({
        data: {
          ...this.state.data,
          proflieUrl: e.target.result,
        },
      });
    };

    reader.onprogress = (data) => {
      if (data.lengthComputable) {
        var progress = parseInt((data.loaded / data.total) * 100, 10);
        this.setState({
          imagePercentage: progress,
        });
      }
    };

    if (files) {
      reader.readAsDataURL(files);
    }
  };

  handleImageProgress = () =>
    this.state.imagePercentage ? (
      <React.Fragment>
        <CustomLinearProgress
          value={this.state.imagePercentage}
          variant="determinate"
        />
        {this.state.imagePercentage === 100 ? (
          <React.Fragment>Upload Complete</React.Fragment>
        ) : (
          <React.Fragment>{this.state.imagePercentage}%</React.Fragment>
        )}
      </React.Fragment>
    ) : null;

  handleFileUpload = (e) => {
    let reader = new FileReader();
    this.setState({
      data: { ...this.state.data, pdfFile: e.target.files[0] },
    });
    let files = e.target.files[0];
    reader.onload = (e) => {
      this.setState({
        fileUrl: e.target.result,
      });
    };

    reader.onprogress = (data) => {
      if (data.lengthComputable) {
        var progress = parseInt((data.loaded / data.total) * 100, 10);
        this.setState({
          filePercentage: progress,
        });
      }
    };

    if (files) {
      reader.readAsDataURL(files);
    }
  };

  handleFileProgress = () =>
    this.state.filePercentage ? (
      <React.Fragment>
        <CustomLinearProgress
          value={this.state.filePercentage}
          variant="determinate"
        />
        {this.state.filePercentage === 100 ? (
          <React.Fragment>Upload Complete</React.Fragment>
        ) : (
          <React.Fragment>{this.state.filePercentage}%</React.Fragment>
        )}
      </React.Fragment>
    ) : null;

  checkError = (TitleError, PdfFileError) => {
    let titleError = TitleError;
    let pageCountError = "";
    let priceError = "";
    let descriptionError = "";
    let bookCoverError = "";
    let pdfFileError = PdfFileError;

    if (this.state.data.title.length < 5) {
      titleError = "Title must be minimum of length 5";
    }

    if (this.state.data.pageCount <= 0) {
      pageCountError = "Page count mustnot be less than 1";
    }

    if (this.state.data.price <= 0) {
      priceError = "Price mustnot be less than 1";
    }

    if (this.state.data.description.length < 3) {
      descriptionError = "description must be minimum of length 3";
    }

    if (!this.state.data.profileUrl) {
      bookCoverError = "book cover must be uploaded";
    }

    if (
      titleError ||
      pageCountError ||
      priceError ||
      descriptionError ||
      bookCoverError ||
      pdfFileError
    ) {
      this.setState({
        titleError,
        pageCountError,
        priceError,
        descriptionError,
        bookCoverError,
        pdfFileError,
      });
      return true;
    } else {
      this.setState({
        titleError: "",
        pageCountError: "",
        priceError: "",
        descriptionError: "",
        bookCoverError: "",
        pdfFileError: "",
      });
      return false;
    }
  };

  handleRegisterAuthor = () => {
    this.props.history.push("/_administration_/author/add");
  };

  handleAddCategory = () => {
    this.props.history.push("/_administration_/category/add");
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      this.setState({ loading: true });
      let fileData = new FormData();
      fileData.append("bookCover", this.state.data.proflieUrl);
      fileData.append("bookFile", this.state.data.pdfFile);
      fileData.append("title", this.state.data.title);
      fileData.append("authorId", this.state.data.author);
      fileData.append("genre", this.state.data.genre);
      fileData.append("publishedDate", this.state.data.publishedDate);
      fileData.append("pageCount", this.state.data.pageCount);
      fileData.append("price", this.state.data.price);
      fileData.append("description", this.state.data.description);
      if (this.props.editStatus) {
        const response = await Axios.put(
          `${url}/api/books/${this.props.match.params.bookId}`,
          fileData,
          {
            headers: {
              "x-auth-token": this.props.adminToken,
            },
          }
        );
        if (response.data.errorMessage || response.data.error) {
          if (response.data.errorMessage) {
            this.checkError(response.data.errorMessage, "");
            this.setState({ loading: false });
          } else {
            this.checkError("", response.data.error);
            this.setState({ loading: false });
          }
        } else {
          if (response.data.success && errorStatus === false) {
            this.setState({ success: response.data.success });
            this.props.history.push("/_administration_/book/view");
          }
        }
      } else {
        const response = await Axios.post(`${url}/api/books`, fileData, {
          headers: {
            "x-auth-token": this.props.adminToken,
          },
        });
        if (response.data.errorMessage || response.data.error) {
          if (response.data.errorMessage) {
            this.checkError(response.data.errorMessage, "");
            this.setState({ loading: false });
          } else {
            this.checkError("", response.data.error);
            this.setState({ loading: false });
          }
        } else {
          if (response.data.success && errorStatus === false) {
            this.setState({ success: response.data.success });
            this.props.history.push("/_administration_/book/view");
          }
        }
      }
    }
  };

  handleWheel = (refValue) => {
    refValue.current.blur();
    setTimeout(() => refValue.current.focus(), 100);
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <NavBar />
        <div className={classes.root}>
          <AdminPageTitle title="Add Book" />
          <Divider />
          <form onSubmit={this.handleSubmit}>
            <TextField
              name="title"
              type="string"
              label="Title"
              fullWidth
              required
              margin="normal"
              variant="outlined"
              style={{ outline: "none" }}
              placeholder="Enter title of book"
              error={this.state.titleError ? true : false}
              helperText={this.state.titleError}
              InputProps={{
                classes: {
                  notchedOutline: classes.notchedOutline,
                  focused: classes.focused,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              className={classes.inputWithMargin}
              value={this.state.data.title}
              onChange={this.handleChange}
            />

            <TextField
              name="author"
              label="Author"
              select
              fullWidth
              required
              margin="normal"
              variant="outlined"
              style={{ outline: "none" }}
              helperText="If the author you want is not listed, go to add the author in author section"
              SelectProps={{
                native: true,
              }}
              InputProps={{
                classes: {
                  notchedOutline: classes.notchedOutline,
                  focused: classes.focused,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              className={classes.inputWithoutMargin}
              value={this.state.data.author}
              onChange={this.handleChange}
            >
              <option value="">Select Any One</option>
              {this.state.authorList.map((author, index) => (
                <option key={index} value={author._id}>
                  {`${author.firstName} ${author.lastName}`}
                </option>
              ))}
            </TextField>

            <TextField
              name="genre"
              select
              label="Genre"
              fullWidth
              required
              margin="normal"
              variant="outlined"
              style={{ outline: "none" }}
              helperText="If genre you want is not listed go to genre section and add the genre"
              SelectProps={{
                native: true,
              }}
              InputProps={{
                classes: {
                  notchedOutline: classes.notchedOutline,
                  focused: classes.focused,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              className={classes.inputWithMargin}
              value={this.state.data.genre}
              onChange={this.handleChange}
            >
              <option value="">Select Any One</option>
              {this.state.categoryList.map((genre, index) => (
                <option key={index} value={genre.name}>
                  {genre.name}
                </option>
              ))}
            </TextField>
            <TextField
              name="publishedDate"
              type="date"
              label="Published Date"
              required
              margin="normal"
              variant="outlined"
              InputProps={{
                classes: {
                  notchedOutline: classes.notchedOutline,
                  focused: classes.focused,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              className={classes.inputWithoutMargin}
              value={this.state.data.publishedDate}
              onChange={this.handleChange}
            />

            <TextField
              name="pageCount"
              type="number"
              label="Total Page Number"
              required
              margin="normal"
              variant="outlined"
              placeholder="Enter total page number of the book"
              error={this.state.pageCountError ? true : false}
              helperText={this.state.pageCountError}
              InputProps={{
                classes: {
                  notchedOutline: classes.notchedOutline,
                  focused: classes.focused,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              className={classes.inputWithMargin}
              inputRef={this.state.countRef}
              onWheel={() => this.handleWheel(this.state.countRef)}
              value={this.state.data.pageCount}
              onChange={this.handleChange}
            />

            <TextField
              name="price"
              type="number"
              label="Price"
              required
              margin="normal"
              variant="outlined"
              placeholder="Assign Price for the book"
              error={this.state.priceError ? true : false}
              helperText={this.state.priceError}
              InputProps={{
                classes: {
                  notchedOutline: classes.notchedOutline,
                  focused: classes.focused,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              className={classes.inputWithoutMargin}
              inputRef={this.state.priceRef}
              onWheel={() => this.handleWheel(this.state.priceRef)}
              value={this.state.data.price}
              onChange={this.handleChange}
            />

            <TextField
              name="description"
              type="string"
              label="Description"
              required
              multiline
              fullWidth
              margin="normal"
              rows={4}
              rowsMax={8}
              variant="outlined"
              placeholder="write brief description about the book"
              style={{ outline: "none" }}
              error={this.state.descriptionError ? true : false}
              helperText={this.state.descriptionError}
              InputProps={{
                classes: {
                  focused: classes.focused,
                  notchedOutline: classes.notchedOutline,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              value={this.state.data.description}
              onChange={this.handleChange}
            />

            <Grid container spacing={3}>
              <Grid
                item
                sx={12}
                sm={12}
                md={6}
                xl={6}
                lg={6}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                {this.state.data.profileUrl && (
                  <img
                    src={this.state.data.profileUrl}
                    alt="Book Cover Page"
                    style={{ width: 200, height: 200 }}
                  />
                )}
                <label style={{ fontSize: 18 }}>
                  Choose Cover Image for book
                </label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={this.handleImageUpload}
                />
                <div style={{ padding: 10 }}>{this.handleImageProgress()}</div>
                <div style={{ color: "red" }}> {this.state.bookCoverError}</div>
              </Grid>

              <Grid
                item
                sx={12}
                sm={12}
                md={6}
                xl={6}
                lg={6}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <label style={{ fontSize: 18 }}>Choose book file</label>
                <input
                  accept="application/pdf"
                  type="file"
                  onChange={this.handleFileUpload}
                />
                <div style={{ color: "red" }}> {this.state.pdfFileError}</div>
                <div style={{ padding: 10 }}>{this.handleFileProgress()}</div>
              </Grid>
            </Grid>

            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                variant="outlined"
                type="submit"
                className={classes.buttonStyle}
              >
                Submit
              </Button>
              {this.stateloading && <FormLoader />}
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(withRouter(AddBook)));
